module.exports = __webpack_public_path__ + "static/img/u15.5e1e68d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/u15.jpg
// module id = nbok
// module chunks = 0